import {
    SAVED_COURSES_META_FAILURE,
    SAVED_COURSES_META_REQUEST,
    SAVED_COURSES_META_SUCCESS,
} from './savedCourseTypes'

const initialState = {
    loading: false,
    loadingMessage: '',
    fetchSuccess: false,
    savedCoursesMeta: [],
    message: '',
    error: '',
}

const reducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case SAVED_COURSES_META_REQUEST:
            return {
                ...state,
                loading: true,
                loadingMessage: 'Fetching saved courses...',
                fetchSuccess: false,
                savedCoursesMeta: [],
                message: '',
                error: '',
            }
        case SAVED_COURSES_META_SUCCESS:
            return {
                ...state,
                loading: false,
                loadingMessage: '',
                fetchSuccess: true,
                savedCoursesMeta: action.payload,
                message: '',
                error: '',
            }
        case SAVED_COURSES_META_FAILURE:
            return {
                ...state,
                loading: false,
                loadingMessage: '',
                fetchSuccess: false,
                savedCoursesMeta: [],
                message: '',
                error: action.payload,
            }
        default:
            return state
    }
}

export default reducer
